import apiClient from "./client";
import type { Book, GetBooksParams, Paginated, TestSummary } from "@/types";

/**
 * Books API.
 * Backend endpoints: GET /books (paginated), GET /books/{id},
 * GET /books/{id}/tests
 */

export async function getBooks(
  { page = 1, size = 100 }: GetBooksParams = {}
): Promise<Paginated<Book>> {
  const { data } = await apiClient.get<Paginated<Book>>("/books", {
    params: { page, size },
  });
  return data;
}

export async function getBook(bookId: number): Promise<Book> {
  const { data } = await apiClient.get<Book>(`/books/${bookId}`);
  return data;
}

export async function getBookTests(bookId: number): Promise<TestSummary[]> {
  const { data } = await apiClient.get<TestSummary[]>(
    `/books/${bookId}/tests`
  );
  return data;
}

// Resolve a book by its code (e.g. "C18"), case-insensitive.
export async function getBookByCode(code: string): Promise<Book | null> {
  const { items } = await getBooks({ page: 1, size: 100 });
  const target = String(code).toUpperCase();
  return items.find((b) => String(b.code).toUpperCase() === target) || null;
}
